import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const checkboxIconFn = /* @__PURE__ */ createRecipe('checkbox-icon', {}, [])

const checkboxIconVariantMap = {}

const checkboxIconVariantKeys = Object.keys(checkboxIconVariantMap)

export const checkboxIcon = /* @__PURE__ */ Object.assign(memo(checkboxIconFn.recipeFn), {
  __recipe__: true,
  __name__: 'checkboxIcon',
  __getCompoundVariantCss__: checkboxIconFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: checkboxIconVariantKeys,
  variantMap: checkboxIconVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, checkboxIconVariantKeys)
  },
  getVariantProps: checkboxIconFn.getVariantProps,
})